import * as Types from './contentfulTypes';

import gql from 'graphql-tag';
import * as ApolloReactCommon from 'react-apollo';
export const AssetUrlFragmentDoc = gql`
    fragment AssetUrl on Asset {
  url
}
    `;
export const AboutDepartmentFragmentDoc = gql`
    fragment AboutDepartment on UniversityProgramPageContent {
  aboutDepartment {
    title
    description
    textOnLeft
    visual {
      ...AssetUrl
    }
  }
}
    ${AssetUrlFragmentDoc}`;
export const AboutUniversityFragmentDoc = gql`
    fragment AboutUniversity on UniversityProgramPageContent {
  aboutUniversity {
    title
    description
    textOnLeft
    visual {
      ...AssetUrl
    }
  }
}
    ${AssetUrlFragmentDoc}`;
export const AtAGlanceFieldsFragmentDoc = gql`
    fragment AtAGlanceFields on AtAGlance {
  courseCount
  finalDeadlineInfo
  hoursPerWeek
  location
  locationCaption
  paymentDetails
  programDescription
  programEnrollmentDate
  programStartDate
  programFutureDates
  ranking
  timeFrame
  tuition
  tuitionCaption
  bannerAtAGlanceTitle1
  bannerAtAGlanceDescription1
  bannerAtAGlanceTitle2
  bannerAtAGlanceDescription2
  bannerAtAGlanceTitle3
  bannerAtAGlanceDescription3
  bannerAtAGlanceTitle4
  bannerAtAGlanceDescription4
  bannerAtAGlanceTitle5
  bannerAtAGlanceDescription5
}
    `;
export const AtAGlanceFragmentDoc = gql`
    fragment AtAGlance on UniversityProgramPageContent {
  atAGlance {
    ...AtAGlanceFields
  }
}
    ${AtAGlanceFieldsFragmentDoc}`;
export const DegreeFacultyFragmentDoc = gql`
    fragment DegreeFaculty on UniversityProgramPageContent {
  facultyCollection {
    items {
      name
      position
      introduction
      profilePicture {
        ...AssetUrl
      }
    }
  }
}
    ${AssetUrlFragmentDoc}`;
export const EventInfoFieldsFragmentDoc = gql`
    fragment EventInfoFields on UpcomingEvent {
  month
  day
  event
}
    `;
export const EventInfoFragmentDoc = gql`
    fragment EventInfo on UniversityProgramPageContent {
  upcomingEventsCollection {
    items {
      ...EventInfoFields
    }
  }
}
    ${EventInfoFieldsFragmentDoc}`;
export const FaqFieldsFragmentDoc = gql`
    fragment FaqFields on Faq {
  question
  answer
}
    `;
export const FaqsFragmentDoc = gql`
    fragment Faqs on UniversityProgramPageContent {
  faqsCollection {
    items {
      ...FaqFields
    }
  }
}
    ${FaqFieldsFragmentDoc}`;
export const FinancialAidFaqsFragmentDoc = gql`
    fragment FinancialAidFaqs on UniversityProgramPageContent {
  financialAidFaqsCollection {
    items {
      question
      answer
    }
  }
}
    `;
export const HistoryOfOnlineLearningFragmentDoc = gql`
    fragment HistoryOfOnlineLearning on UniversityProgramPageContent {
  historyOfOnlineLearning {
    title
    description
    textOnLeft
    visual {
      ...AssetUrl
    }
  }
}
    ${AssetUrlFragmentDoc}`;
export const MobileLexUpsellFragmentDoc = gql`
    fragment MobileLexUpsell on UniversityProgramPageContent {
  mobileLexUpsell {
    title
    description
    visual {
      ...AssetUrl
    }
  }
}
    ${AssetUrlFragmentDoc}`;
export const ProgramTestimonialFragmentDoc = gql`
    fragment ProgramTestimonial on UniversityProgramTestimonial {
  image {
    ...AssetUrl
  }
  authorName
  authorTitle
  text
  videoEmbedUrl
  entryTitle
}
    ${AssetUrlFragmentDoc}`;
export const PartnerInformationFieldsFragmentDoc = gql`
    fragment PartnerInformationFields on PartnerInformation {
  partnerName
  primaryColor
  secondaryColor
  partnerLogo {
    ...AssetUrl
  }
  partnerMonotoneLogo {
    ...AssetUrl
  }
  bannerImage {
    ...AssetUrl
  }
  bannerVideo {
    ...ProgramTestimonial
  }
}
    ${AssetUrlFragmentDoc}
${ProgramTestimonialFragmentDoc}`;
export const PartnerInformationFragmentDoc = gql`
    fragment PartnerInformation on UniversityProgramPageContent {
  partnerInformation {
    ...PartnerInformationFields
  }
}
    ${PartnerInformationFieldsFragmentDoc}`;
export const MarketingContentFieldsFragmentDoc = gql`
    fragment MarketingContentFields on MarketingContent {
  title
  subtitle
  description
  callToActionLink
  callToActionLabel
  visual {
    ...AssetUrl
  }
  visualAlternativeText
  textOnLeft
  openLinkInNewTab
}
    ${AssetUrlFragmentDoc}`;
export const ProgramSpecializationsFragmentDoc = gql`
    fragment ProgramSpecializations on UniversityProgramPageContent {
  programSpecializationsCollection {
    items {
      ...MarketingContentFields
    }
  }
}
    ${MarketingContentFieldsFragmentDoc}`;
export const SpecializationFieldsFragmentDoc = gql`
    fragment SpecializationFields on SpecializationContent {
  slug
  specializationOverview
}
    `;
export const SpecializationsFragmentDoc = gql`
    fragment Specializations on UniversityProgramPageContent {
  specializationsCollection {
    items {
      ...SpecializationFields
    }
  }
}
    ${SpecializationFieldsFragmentDoc}`;
export const NavigationElementFieldsFragmentDoc = gql`
    fragment NavigationElementFields on NavigationElement {
  route
  label
  id
  isIndexPage
}
    `;
export const DegreePageContentFragmentDoc = gql`
    fragment DegreePageContent on UniversityProgramPageContent {
  ...AboutDepartment
  ...AboutUniversity
  ...AtAGlance
  ...DegreeFaculty
  ...EventInfo
  ...Faqs
  ...FinancialAidFaqs
  ...HistoryOfOnlineLearning
  ...MobileLexUpsell
  ...PartnerInformation
  ...ProgramSpecializations
  ...Specializations
  aboutProgramHeader
  aboutProgramCollection {
    items {
      ...MarketingContentFields
    }
  }
  additionalAdmissionResources
  applicationProcess
  bannerNotification
  careerOutcome
  careerServices
  classProfile
  curriculum
  degreeDisclaimer
  expressionOfInterestContainer {
    applyButtonText
    applyButtonUrl
    emailMeButtonText
    emailMeConfirmationText
    emailMeFormHeaderText
    hostedApplicationUrl
    productEnrollmentFlow
    programInterestText
  }
  facultyCollection {
    items {
      profilePicture {
        ...AssetUrl
      }
      name
      position
      introduction
    }
  }
  financialAid
  financialAidFaqsCollection {
    items {
      ...FaqFields
    }
  }
  faqsHeader
  programAudience
  programCategory
  programCategoryId
  programFlexibility
  programLength
  programName
  programShortName
  slug
  tuition
  navigationElementsCollection {
    items {
      ...NavigationElementFields
    }
  }
  openCourseBanner
  openCourseBannerLink
  programBenefitsOverview
  programHighlights
  relatedNewsCollection {
    items {
      ...MarketingContentFields
    }
  }
  stackabilityInfo {
    ...MarketingContentFields
  }
  studentExperienceOverview
  studentExperienceHighlightsCollection {
    items {
      ...MarketingContentFields
    }
  }
  testimonialsTitle
  testimonialsCollection {
    items {
      sys {
        id
      }
      image {
        title
        description
        width
        height
        url(transform: {quality: 60})
      }
      entryTitle
      authorName
      authorTitle
      authorOrganization
      text
      productName
      productTypes
      productCategories
      productSlug
    }
  }
  studentStoriesCollection {
    items {
      ...ProgramTestimonial
    }
  }
}
    ${AboutDepartmentFragmentDoc}
${AboutUniversityFragmentDoc}
${AtAGlanceFragmentDoc}
${DegreeFacultyFragmentDoc}
${EventInfoFragmentDoc}
${FaqsFragmentDoc}
${FinancialAidFaqsFragmentDoc}
${HistoryOfOnlineLearningFragmentDoc}
${MobileLexUpsellFragmentDoc}
${PartnerInformationFragmentDoc}
${ProgramSpecializationsFragmentDoc}
${SpecializationsFragmentDoc}
${MarketingContentFieldsFragmentDoc}
${AssetUrlFragmentDoc}
${FaqFieldsFragmentDoc}
${NavigationElementFieldsFragmentDoc}
${ProgramTestimonialFragmentDoc}`;
export const AdmissionsLinkFragmentDoc = gql`
    fragment AdmissionsLink on AdmissionsApplicationRequirementsLinks {
  entries {
    __typename
    block {
      __typename
      sys {
        id
      }
      ... on Faq {
        question
        answer
      }
    }
  }
}
    `;
export const AdmissionsContentFragmentDoc = gql`
    fragment AdmissionsContent on Admissions {
  applicationRequirements {
    json
    links {
      ...AdmissionsLink
    }
  }
}
    ${AdmissionsLinkFragmentDoc}`;
export const LandingPageEoiFieldsFragmentDoc = gql`
    fragment LandingPageEoiFields on UniversityProgramEoi {
  overrideProgramSlug
  applyButtonText
  applyButtonUrl
  emailMeButtonText
  emailMeConfirmationText
  emailMeFormHeaderText
  hostedApplicationUrl
  productEnrollmentFlow
  programInterestText
}
    `;
export const LandingPageAtAGlanceFieldsFragmentDoc = gql`
    fragment LandingPageAtAGlanceFields on AtAGlance {
  courseCount
  finalDeadlineInfo
  hoursPerWeek
  location
  locationCaption
  paymentDetails
  programDescription
  programEnrollmentDate
  programStartDate
  programFutureDates
  ranking
  timeFrame
  tuition
  tuitionCaption
  bannerAtAGlanceTitle1
  bannerAtAGlanceDescription1
  bannerAtAGlanceTitle2
  bannerAtAGlanceDescription2
  bannerAtAGlanceTitle3
  bannerAtAGlanceDescription3
  bannerAtAGlanceTitle4
  bannerAtAGlanceDescription4
  bannerAtAGlanceTitle5
  bannerAtAGlanceDescription5
}
    `;
export const DegreeLandingPageContentFragmentDoc = gql`
    fragment DegreeLandingPageContent on LandingPage {
  slug
  programName
  programShortName
  partnerInformation {
    ...PartnerInformationFields
  }
  title
  programOverview
  expressionOfInterest {
    ...LandingPageEoiFields
  }
  atAGlance {
    ...LandingPageAtAGlanceFields
  }
}
    ${PartnerInformationFieldsFragmentDoc}
${LandingPageEoiFieldsFragmentDoc}
${LandingPageAtAGlanceFieldsFragmentDoc}`;
export const GetDegreePageContentDocument = gql`
    query getDegreePageContent($slug: String!, $locale: String!, $preview: Boolean!) {
  universityProgramPageContentCollection(
    locale: $locale
    where: {slug: $slug}
    limit: 1
    preview: $preview
  ) {
    items {
      ...DegreePageContent
    }
  }
  admissionsCollection(
    locale: $locale
    where: {slug: $slug}
    limit: 1
    preview: $preview
  ) {
    items {
      ...AdmissionsContent
    }
  }
}
    ${DegreePageContentFragmentDoc}
${AdmissionsContentFragmentDoc}`;
export type GetDegreePageContentQueryResult = ApolloReactCommon.QueryResult<Types.GetDegreePageContentQuery, Types.GetDegreePageContentQueryVariables>;
export const GetDegreeLandingPageContentDocument = gql`
    query getDegreeLandingPageContent($slug: String!, $variantId: String) {
  landingPageCollection(where: {slug: $slug, variantId: $variantId}, limit: 1) {
    items {
      ...DegreeLandingPageContent
    }
  }
}
    ${DegreeLandingPageContentFragmentDoc}`;
export type GetDegreeLandingPageContentQueryResult = ApolloReactCommon.QueryResult<Types.GetDegreeLandingPageContentQuery, Types.GetDegreeLandingPageContentQueryVariables>;